<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">Support Queries </h2>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Support Queries</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                :min-width="200"
                align="left"
                label="User Details"
              >
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>{{ props.row.name }}</div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column
                :min-width="200"
                align="left"
                label="Phone Number"
              >
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.phone }}</div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Message">
                <div slot-scope="props">
                  <div>
                    <div>{{ props.row.message.substring(0, 50) }}</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column :min-width="200" align="left" label="Date">
                <div slot-scope="props">
                  <div>
                    <div>{{ formatDate(props.row.created_at) }}</div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Control">
                <div slot-scope="props">
                  <button
                    class="btn btn-fill"
                    @click="editClickhandler(props.row)"
                  >
                    View 
                  </button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import users from "./orders";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";
import moment from 'moment';

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        console.log(this.searchedData);
        console.log("search data ");
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      noDataMessage: "",
      loading: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["name", "phone", "message", "created_at"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "phone",
          label: "Phone Number",
          minWidth: 250,
        },

        {
          prop: "message",
          label: "Message",
          minWidth: 120,
        },
        {
          prop: "created_at",
          label: "Date",
          minWidth: 200,
        },
      ],
      tableData: [],
      tableDatas: [],
      searchedData: [],
      fuseSearch: null,
      currentOrder: {},
    };
  },
  async mounted() {
    this.loading = true;
    let test = await this.$apiService.getCall("user/support-messages");
    console.log(test);
    this.tableDatas = test.apidata.Data || [];
    this.tableData = this.tableDatas.reverse();
    console.log(this.tableData);
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "phone", "message", "created_at"],
      threshold: 0.3,
    });
    this.loading = false;
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      console.log("search ");
      console.log(this.searchQuery);
      if (this.searchQuery !== "") {
        result = this.fuseSearch.search(this.searchQuery);
        result = result.map((a) => a.item);
      }
      this.searchedData = result;
    },
  },
  methods: {
    editClickhandler(userInformation) {
      console.log(userInformation);
      this.$router.push("edit-support_query?id=" + userInformation._id);
    },

    formatDate(created_at) {
      return moment(created_at).format("DD-MM-YYYY hh:mm a");
    },
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}

.form-group .search-input input {
  color: #fff !important;
}
</style>
